<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <!-- <el-input
        v-model="params.title"
        placeholder="请输入标题"
        clearable
        size="small"
        class="param-input"
      ></el-input> -->
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" width="220">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.title || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面图" align="center" width="120" prop="img">
        <template slot-scope="scope">
          <img-load
            :width="'70px'"
            :height="'70px'"
            :src="imgUrl + scope.row.img"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="图文预览"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="getEditorData(scope.row)"
          >
            预览
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="说明" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.desc || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.sort || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="120">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status">开启</el-tag>
          <el-tag type="danger" v-else>关闭</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="start" label="开始时间" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ changeTime1(scope.row.start) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="end" label="结束时间" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ changeTime1(scope.row.end) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增or修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="600px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="120px" :rules="rules" ref="form">
        <el-form-item label="标题" prop="title" style="width: 500px">
          <el-input v-model="form.title"></el-input>
        </el-form-item>

        <el-form-item label="封面" prop="img">
          <base-upload
            :cover="form.img"
            :action="action"
            @successCallback="successCallback"
            :wSize="360"
            :hSize="360"
            :width="'150px'"
            :height="'150px'"
          ></base-upload>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-button
            type="warning"
            size="mini"
            icon="el-icon-edit"
            @click="lookEidt"
          >
            配置内容
          </el-button>
        </el-form-item>
        <el-form-item label="说明" prop="desc" style="width: 500px">
          <el-input type="textarea" :rows="3" v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort" style="width: 500px">
          <el-input v-model.number="form.sort"></el-input>
        </el-form-item>
        <el-form-item label="状态:" prop="status" style="width: 280px">
          <el-select
            size="small"
            v-model="form.status"
            placeholder="请选择状态"
          >
            <el-option
              v-for="item in statues"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择日期" prop="time" style="width: 500px">
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            @change="changesTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="跳转方式:" prop="hrefType">
          <el-select
            v-model.number="linkType"
            size="small"
            placeholder="跳转方式"
          >
            <el-option
              v-for="item in linkTypeList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接地址" prop="joinLink" v-if="linkType == 1">
          <el-input v-model.number="form.joinLink"></el-input>
        </el-form-item>
        <el-form-item label="链接地址:" prop="joinLink" v-if="linkType == 2">
          <el-select
            v-model.number="form.joinLink"
            size="small"
            placeholder="链接地址"
            filterable
          >
            <el-option
              v-for="item in linkList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="帖子ID"
          prop="postId"
          v-if="form.joinLink == 'yinseinner://postDetails?id='"
        >
          <el-input v-model="postId"></el-input>
        </el-form-item>
        <el-form-item
          label="意见榜单ID"
          prop="solicitId"
          v-if="form.joinLink == 'yinseinner://solicit_opinion_page?id='"
        >
          <el-input v-model="solicitId"></el-input>
        </el-form-item>
        <el-form-item
          label="专题ID"
          prop="topicId"
          v-if="form.joinLink == 'yinseinner://topic_page?id='"
        >
          <el-input v-model="topicId"></el-input>
        </el-form-item>
        <el-form-item
          label="专题标题"
          prop="topicId"
          v-if="form.joinLink == 'yinseinner://topic_page?id='"
        >
          <el-input v-model="topicTitle"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="addOrEditSend()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!--预览-->
    <look ref="look"></look>
    <!-- 图文 -->
    <Config ref="config" />
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";
import { changeTime } from "@/utils/global";
import Look from "./components/look";
import Config from "./components/config.vue";

export default {
  components: {
    Look,
    Config,
  },
  data() {
    return {
      imgUrl: baseConfig.imgUrl,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        title: undefined,
      },
      rules: {
        contact: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
        ],
      },
      dialogTitle: "",
      dialogVisible: false,
      time: "",
      linkType: undefined,
      form: {
        id: undefined,
        title: undefined, // 标题
        img: undefined, // 封面图
        content: undefined, // 内容
        desc: undefined, // 说明
        sort: undefined, // 排序
        status: 1, // 状态
        start: undefined, // 开始时间
        end: undefined, // 结束时间
        joinLink: undefined,
      },
      statues: [
        {
          label: "关闭",
          value: 0,
        },
        {
          label: "开启(不可参与)",
          value: 1,
        },
        {
          label: "开启(可参与)",
          value: 2,
        },
      ],
      enables: [
        { label: "启用", value: 1 },
        { label: "禁用", value: 0 },
      ],
      linkTypeList: [
        { label: "外部浏览器跳转", value: 1 },
        { label: "内部浏览器跳转", value: 2 },
      ],
      linkList: [
        { label: "专题", value: "yinseinner://topic_page?id=" },
        { label: "帖子详情", value: "yinseinner://postDetails?id=" },
        { label: "会员", value: "yinseinner://vip_page" },
        { label: "钱包", value: "yinseinner://wallet_page" },
        { label: "全民代理", value: "yinseinner://universal_agent" },
        { label: "参赛视频", value: "yinseinner://competition_video_page" },
        { label: "AV解说", value: "yinseinner://av_commentary_page" },
        { label: "抽奖", value: "yinseinner://new_year_lottery_page" },
        { label: "裸聊", value: "yinseinner://nake_chat_page" },
        { label: "娱乐", value: "yinseinner://entertainment_page" },
        { label: "ai脱衣", value: "yinseinner://aiUndress" },
        { label: "签到", value: "yinseinner://sign_page" },
        { label: "意见榜单", value: "yinseinner://solicit_opinion_page?id=" },
        { label: "问题反馈", value: "yinseinner://feedback_page" },
      ],
      topicId: "",
      topicTitle: "",
      postId: "", // 帖子ID
      solicitId: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getSolicitOpinions(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            //图片源站地址
            if (res.data.list.length > 0) {
              for (let i = 0; i < res.data.list.length; i++) {
                var content = res.data.list[i].content;
                if (content != "") {
                  res.data.list[i].content = content.replace(
                    /<img src="/g,
                    '<img src="'
                  );
                }
              }
            }
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增or修改方法
    addOrEditSend() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (
            this.form.joinLink == "yinseinner://postDetails?id=" &&
            !this.postId
          ) {
            this.$message({
              type: "error",
              message: "请输入帖子ID",
            });
            return;
          }
          if (
            this.form.joinLink == "yinseinner://solicit_opinion_page?id=" &&
            !this.solicitId
          ) {
            this.$message({
              type: "error",
              message: "请输入意见榜单ID",
            });
            return;
          }
          if (
            this.form.joinLink == "yinseinner://topic_page?id=" &&
            !this.topicId
          ) {
            this.$message({
              type: "error",
              message: "请输入专题ID",
            });
            return;
          }
          if (
            this.form.joinLink == "yinseinner://topic_page?id=" &&
            !this.topicTitle
          ) {
            this.$message({
              type: "error",
              message: "请输入专题标题",
            });
            return;
          }
          if (this.form.joinLink == "yinseinner://topic_page?id=") {
            this.form.joinLink =
              this.form.joinLink + this.topicId + `&title=${this.topicTitle}`;
          }
          if (this.form.joinLink == "yinseinner://postDetails?id=") {
            this.form.joinLink = this.form.joinLink + this.postId;
          }
          if (this.form.joinLink == "yinseinner://solicit_opinion_page?id=") {
            this.form.joinLink = this.form.joinLink + this.solicitId;
          }
          if (this.dialogTitle === "新增") {
            API.addSolicitOpinions(this.form).then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
                this.handleClose();
                this.getList();
              } else {
                this.$message({
                  type: "error",
                  message: res.data || res.msg || res.tip || "新增失败",
                });
              }
            });
          } else {
            this.form.content = this.form.content.replace(
              /https:\/\/xxx.xxx.com\//g,
              ""
            );
            API.editSolicitOpinions(this.form).then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "更新成功",
                });
                this.handleClose();
                this.getList();
              } else {
                this.$message({
                  type: "error",
                  message: res.data || res.msg || res.tip || "更新失败",
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.title = undefined;
      this.form.img = undefined;
      this.form.content = undefined;
      this.form.joinLink = undefined;
      this.form.desc = undefined;
      this.form.sort = undefined;
      this.form.status = 0;
      this.form.start = undefined;
      this.form.end = undefined;
      this.time = undefined;
      this.linkType = undefined;
      this.dialogTitle = "";
      this.dialogVisible = false;
      this.topicId = "";
      this.topicTitle = "";
      this.postId = ""; // 帖子ID
      this.solicitId = "";
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime1(time) {
      return uniteDate(time);
    },
    // 时间触发回调
    changesTime(time) {
      if (time) {
        this.form.start = changeTime(time[0]) || "";
        this.form.end = changeTime(time[1]) || "";
      } else {
        this.form.start = "";
        this.form.end = "";
      }
    },
    // 新增标签配置
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        this.form.id = param.id;
        this.form.title = param.title;
        this.form.img = param.img;
        this.form.content = param.content;
        this.form.desc = param.desc;
        this.form.sort = param.sort;
        this.form.status = param.status;
        this.time = [];
        this.time.push(changeTime(param.start));
        this.time.push(changeTime(param.end));
        if (param.joinLink.indexOf("yinseinner") !== -1) {
          this.linkType = 2;
        } else {
          this.linkType = 1;
        }
        if (param.joinLink.indexOf("topic_page") !== -1) {
          const splitArr = param.joinLink.split("=");
          this.form.joinLink = splitArr[0] + "=";
          let urlIndex = param.joinLink.indexOf("?");
          this.topicId = this.getUrlParam(
            param.joinLink.substring(urlIndex),
            "id"
          );
          this.topicTitle = this.getUrlParam(
            param.joinLink.substring(urlIndex),
            "title"
          );
        } else if (param.joinLink.indexOf("postDetails") !== -1) {
          const splitArr = param.joinLink.split("=");
          this.form.joinLink = splitArr[0] + "=";
          let urlIndex = param.joinLink.indexOf("?");
          this.postId = this.getUrlParam(
            param.joinLink.substring(urlIndex),
            "id"
          );
        } else if (param.joinLink.indexOf("solicit_opinion_page") !== -1) {
          const splitArr = param.joinLink.split("=");
          this.form.joinLink = splitArr[0] + "=";
          let urlIndex = param.joinLink.indexOf("?");
          this.solicitId = this.getUrlParam(
            param.joinLink.substring(urlIndex),
            "id"
          );
        } else {
          this.form.joinLink = param.joinLink;
        }
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    getUrlParam(url, name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = url.substr(1).match(reg); //匹配目标参数
      if (r != null) return unescape(r[2]);
      return null; //返回参数值
    },
    // 标签封面上传成功回掉
    successCallback(res) {
      this.form.img = res.data.coverImg;
    },
    getEditorData(row) {
      // 通过代码获取编辑器内容
      let data = row.content;
      this.$refs.look.open(data);
    },
    //打开编辑
    lookEidt() {
      this.$refs.config.open(this.form.id, this.form.content);
    },
    // 保存数据
    saveContent(content) {
      this.form.content = content;
      this.$refs.config.close(); // 关闭编辑器
    },
  },
  provide() {
    return {
      saveContent: this.saveContent,
    };
  },
};
</script>
<style lang="scss" scoped>
.picturePreview {
  max-width: 400px;
  display: flex;
}
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
.form-flex-box {
  display: flex;
  .el-form-item {
    flex: 1;
  }
}
.tagBox {
  display: inline-block;
  margin-right: 5px;
}
</style>
